import merchantService from "../services/merchant.service";

export const enableMerchant = async ({ account_urn, business_urn }) => {
  return await merchantService.enableMerchant({ account_urn, business_urn });
};

export const getMerchant = async ({ account_urn }) => {
  const res = await merchantService.getMerchant({ account_urn });
  return res?.data?.body;
};

export const getMenu = async ({ account_urn, menu_urn }) => {
  return await merchantService.getMenu({ account_urn, menu_urn });
};

export const getMenus = async ({ account_urn }) => {
  const res = await merchantService.getMenus({ account_urn });
  return res?.data?.body;
};

export const uploadMenu = async ({ account_urn, data }) => {
  return await merchantService.uploadMenu({ account_urn, data });
};

export const createMenu = async ({ account_urn, data }) => {
  return await merchantService.createMenu({ account_urn, data });
};

export const updateMenu = async ({ account_urn, menuUrn, data }) => {
  return await merchantService.updateMenu({ account_urn, menuUrn, data });
};

export const deleteMenu = async ({ account_urn, menuUrn }) => {
  return await merchantService.deleteMenu({ account_urn, menuUrn });
};

export const createMenuSection = async ({ account_urn, menuUrn, data }) => {
  return await merchantService.createMenuSection({
    account_urn,
    menuUrn,
    data,
  });
};

export const updateMenuSection = async ({ account_urn, menuUrn, data }) => {
  return await merchantService.updateMenuSection({
    account_urn,
    menuUrn,
    data,
  });
};

export const createMenuItem = async ({ account_urn, data }) => {
  return await merchantService.createMenuItem({
    account_urn,
    data,
  });
};

export const updateMenuItem = async ({ account_urn, itemUrn, data }) => {
  return await merchantService.updateMenuItem({
    account_urn,
    itemUrn,
    data,
  });
};

export const getMenuItems = async ({ account_urn }) => {
  const res = await merchantService.getMenuItems({
    account_urn,
  });

  return res?.data?.body?.products;
};

export const addMenutoOutlet = async ({ account_urn, outletUrn, menuUrn }) => {
  return await merchantService.addMenutoOutlet({
    account_urn,
    outletUrn,
    menuUrn,
  });
};

export const getMenuRewards = async ({ account_urn }) => {
  return await merchantService.getMenuRewards({
    account_urn,
  });
};

export const createMenuReward = async ({ account_urn, data }) => {
  return await merchantService.createMenuReward({
    account_urn,
    data,
  });
};

export const updateMenuReward = async ({ account_urn, urn, data }) => {
  return await merchantService.updateMenuReward({
    account_urn,
    urn,
    data,
  });
};

export const deleteMenuReward = async ({ account_urn, urn }) => {
  return await merchantService.deleteMenuReward({
    account_urn,
    urn,
  });
};

// ====== DISCOUNTS Actions ======

export const getMenuDiscounts = async ({ account_urn }) => {
  return await merchantService.getMenuDiscounts({
    account_urn,
  });
};

export const createMenuDiscount = async ({ account_urn, data }) => {
  return await merchantService.createMenuDiscount({
    account_urn,
    data,
  });
};

export const updateMenuDiscount = async ({ account_urn, urn, data }) => {
  return await merchantService.updateMenuDiscount({
    account_urn,
    urn,
    data,
  });
};

export const deleteMenuDiscount = async ({ account_urn, urn }) => {
  return await merchantService.deleteMenuDiscount({
    account_urn,
    urn,
  });
};

export const getMerchantOrders = async (params) => {
  return await merchantService.getMerchantOrders(params);
};
